export const audioTypes = [
  "mp3",
  "wav",
  "aac",
  "ogg",
  "flac",
  "alac",
  "aiff",
  "wma",
  "dsd",
];

export const videoTypes = [
  "mp4",
  "avi",
  "mkv",
  "mov",
  "wmv",
  "flv",
  "vp9",
  "3gp",
  "m4a",
  "webm",
  "ogv",
];
